import React, { useState } from "react";
import PropTypes from "prop-types";
import LoginModal from "../LoginModal";
import Modal from "../atoms/Modal";
import isUserLoggedIn from "../../common/helpers/isUserLoggedIn";
import PubmedFormWidget from "./PubmedFormWidget";
import HowToArticleLink from "../Publications/components/HowToArticleLink";
import { eventTrack } from "../../common/helpers/helpers";
import { ANALYTICS_CATEGORIES } from "../cards/common/constants";
import PubmedEntry from "./PubmedEntry";

function PubmedForm(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { linkText, entry, className } = props;
  const edittedEntry = entry ? new PubmedEntry(entry) : null;

  const toggleLoginModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const openModal = () => {
    const ev = ANALYTICS_CATEGORIES.ANALYSIS_PAGE_HEADER_BUTTONS;
    const evType = "Link Publication";
    eventTrack(ev, evType, "");
    setIsModalOpen(true);
  };

  return (
    <span>
      <button
        type="submit"
        className={className}
        onClick={() => openModal()}
        data-tooltip="The linked publications will appear on the publications component on the page of the linked variant."
        data-tooltip-class="publications-tooltip"
      >
        <i className="tw-mr-1 fa fa-file-text-o" />
        {linkText || "Link publication"}
      </button>

      {isUserLoggedIn ? (
        <Modal
          isOpen={isModalOpen}
          isClosableOnBlur={false}
          onRequestClose={() => setIsModalOpen(false)}
          ContentRender={({ forceClose }) => (
            <div className="tw-w-90screen tw-max-w-screen-xl tw-px-6 tw-py-3">
              <div className="tw-text-xl tw-pb-6 tw-pt-3">
                Link Publication and Classify Variant
                <div className="tw-absolute tw-top-4 tw-right-12 tw-text-xs">
                  <HowToArticleLink classes="tw-mr-2" />
                </div>
              </div>
              <PubmedFormWidget
                entry={edittedEntry}
                onCancel={() => forceClose()}
              />
            </div>
          )}
        />
      ) : (
        <LoginModal showModal={isModalOpen} toggleModal={toggleLoginModal} />
      )}
    </span>
  );
}

PubmedForm.propTypes = {
  className: PropTypes.string,
  linkText: PropTypes.string,
  entry: PropTypes.shape({ id: PropTypes.number }),
};

PubmedForm.defaultProps = {
  className: "btn btn-success tw-truncate tw-text-white",
  linkText: "",
  entry: null,
};

export default PubmedForm;
